import { KatapultElement, html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';

class KatapultSavedViewTemplateEditor extends KatapultEditorTemplate {
  static get template() {
    return html``;
  }

  labelChanged(label) {
    this.set('_itemData.name', label);
  }
}

customElements.define('katapult-saved-view-template-editor', KatapultSavedViewTemplateEditor);
